// extracted by mini-css-extract-plugin
export default {"futureRoutineScheduleForForm":"futureRoutineScheduleForForm-tq9eH","label":"label-T6f2N","dateInput":"dateInput-Ayyha","shouldQueueAutomatically":"shouldQueueAutomatically-dPln4"};